import { makeAutoObservable } from 'mobx';
import { ICType, ICLib, ICFunction } from '../../components/Configuration/IConfiguration';

class ICLibStore {
    _configLib: ICLib = {
        itypes: { folders: [], variables: [] },
        functions: { folders: [], variables: [] },
        functionsBlock: { folders: [], variables: [] }
    };

    systemTypesDefault = ['int', 'bool'];

    get systemTypeSelect() {
        return this.systemTypesDefault.map((name: string) => {
            return { id: name, value: name };
        });
    }

    constructor() {
        this.LoadConfigLib();
        makeAutoObservable(this, {}, { autoBind: true });
    }

    async LoadConfigLib() {
        fetch('/ixyber/vision/file/configLib', {
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
        })
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                let newdata = JSON.parse(data);
                if (newdata) {
                    this._configLib = newdata;
                }
            })
            .catch((errorData) => {
                console.error('Failed to load Data: ', errorData);
            });
    }

    configLib = (): ICLib => {
        return this._configLib;
    };

    setConfigLib = (configLib: ICLib) => {
        this._configLib = configLib;
    };

    updateType = (num_type: number, type: ICType) => {
        let temp = { ...this._configLib };
        temp.itypes.variables[num_type] = type;

        this.setConfigLib(temp);
    };

    updateFunction = (num_type: number, func: ICFunction) => {
        let temp = { ...this._configLib };
        temp.functions.variables[num_type] = func;

        this.setConfigLib(temp);
    };
}

export default ICLibStore;
